/**
 * Survey popup script
 */
class P_SurveyPopup {
	constructor() {
		this.initState();
	}

	initState() {
		this.openPopupBtn = $('.open-survey-popup');
		this.surveyPopup = $('.survey-popup');
		this.openForm = this.surveyPopup.find('.open-form');
		this.questionsList = this.surveyPopup.find('.ss-survey');
    this.questions = this.surveyPopup.find('.question-box');
    this.nextBtn = this.surveyPopup.find('.next-question');
    this.prevBtn = this.surveyPopup.find('.prev-question');
		this.submitBtn = $('input[type="submit"');
		this.currentItem = 0;
    this.animationInProgress = false;

		if (this.openPopupBtn.length) {
			this.initEvents();
		}
	}

	initEvents() {
		this.openForm.on('click', e => {
			e.preventDefault();
			$('.popup-form-intro').addClass('is-hidden');
			this.questionsList.addClass('is-visible');
			this.nextBtn.removeClass('is-hidden');
			this.prevBtn.removeClass('is-hidden');
			this.prevBtn.addClass('back-to-intro');
		});

    this.nextBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }
      this.animationInProgress = true;

			console.log('next curIt:', this.currentItem)
			console.log('ilosc', this.questions.length);
			
			this.currentItem++;

      if (this.currentItem >= this.questions.length - 1) {
        this.nextBtn.addClass('is-hidden');
				this.submitBtn.addClass('is-visible');
      }  

      this.questions.removeClass('is-active');
      this.questions.eq(this.currentItem).addClass('is-active');
      this.prevBtn.removeClass('is-hidden');
			this.prevBtn.removeClass('back-to-intro');

      setTimeout(() => {
        this.animationInProgress = false;
      }, 550);
    });

    this.prevBtn.on('click', e => {
			if(this.prevBtn.hasClass('back-to-intro')) {
				e.preventDefault();
        $('.popup-form-intro').removeClass('is-hidden');
				this.questionsList.removeClass('is-visible');
				this.nextBtn.addClass('is-hidden');
				this.prevBtn.addClass('is-hidden');
				this.prevBtn.removeClass('back-to-intro');
			} else {
				e.preventDefault();

				if (this.animationInProgress) {
					return;
				}

				this.animationInProgress = true;

				console.log('prev curIt:', this.currentItem)
				console.log('ilosc', this.questions.length);

				this.currentItem--;

				if (this.currentItem === 0) {
					this.prevBtn.addClass('is-hidden');
					this.prevBtn.addClass('back-to-intro');
				}

				this.questions.removeClass('is-active');
				this.questions.eq(this.currentItem).addClass('is-active');
				this.nextBtn.removeClass('is-hidden');

				setTimeout(() => {
					this.animationInProgress = false;
				}, 550);
			}
    });
  }
}

